import { isDefined } from "@clipboard-health/util-ts";
import { RootPaths } from "@src/appV2/App/paths";
import {
  StickyScrollPageHeader as StickyScrollPageHeaderBase,
  type StickyScrollPageHeaderProps,
} from "@src/appV2/redesign/system/ui-components";
import { useHistory, useLocation } from "react-router-dom";

import { ButtonInternalLink } from "./ButtonInternalLink";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line no-barrel-files/no-barrel-files
export type { StickyScrollPageHeaderProps } from "@src/appV2/redesign/system/ui-components";

interface StickyScrollPageHeaderLocalProps extends Omit<
  StickyScrollPageHeaderProps,
  "navigateBack" | "LinkComponent"
> {
  fallbackGoBackPath?: string;
  navigateBack?: () => void;
}

export function StickyScrollPageHeader(props: StickyScrollPageHeaderLocalProps) {
  const { fallbackGoBackPath = RootPaths.HOME, navigateBack } = props;

  const history = useHistory();
  const location = useLocation();

  return (
    <StickyScrollPageHeaderBase
      {...props}
      navigateBack={
        navigateBack ??
        (() => {
          // no key means we can't go back
          if (isDefined(location.key)) {
            history.goBack();
          } else {
            history.push(fallbackGoBackPath);
          }
        })
      }
      LinkComponent={ButtonInternalLink}
    />
  );
}
